

import templateFeedbackPage from '@/app-template/lib/pages/FeedbackPage.vue';

export default {
  name: "FeedbackPage",
  components: { templateFeedbackPage },
};
